export default __webpack_public_path__ + "images/621aa94af76a9f6667c6452d0a6f042d-psychedlic.jpg";